import { __makeTemplateObject, __rest, __assign } from 'tslib';
import React__default from 'react';
import styled from 'styled-components';
import { Box } from '../box/Box.js';
import { Text } from '../text/Text.js';

var ImageContainer = /*#__PURE__*/styled(Box).withConfig({
  displayName: "Badge__ImageContainer",
  componentId: "sc-y787rc-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  > * {\n    max-width: 100%;\n    width: 100%;\n    height: 100%;\n  }\n"], ["\n  > * {\n    max-width: 100%;\n    width: 100%;\n    height: 100%;\n  }\n"])));
var Badge = function (_a) {
  var _b = _a.size,
    size = _b === void 0 ? ["64px", "80px", "95px"] : _b,
    count = _a.count,
    label = _a.label,
    children = _a.children,
    rest = __rest(_a, ["size", "count", "label", "children"]);
  return React__default.createElement(Box, __assign({
    display: "inline-block"
  }, rest), React__default.createElement(Box, {
    position: "relative",
    alignSelf: "center",
    width: size,
    height: size
  }, React__default.createElement(ImageContainer, null, children), !!count && React__default.createElement(Box, {
    fontSize: size
  }, React__default.createElement(Box, {
    borderRadius: "50%",
    backgroundColor: "greenLantern",
    border: "0.08em solid white",
    width: "1em",
    height: "1em",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    fontSize: "0.4em",
    top: "0",
    right: "-0.2em"
  }, React__default.createElement(Text, {
    as: "span",
    fontFamily: "heading",
    color: "white",
    fontSize: "0.42em"
  }, "x", count)))), label && React__default.createElement(Box, {
    alignSelf: "center",
    marginTop: "5px"
  }, React__default.createElement(Text, {
    forwardedAs: "span",
    variant: "sub",
    textAlign: "center"
  }, label)));
};
var templateObject_1;

export { Badge };
//# sourceMappingURL=Badge.js.map
